/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react';
import { UseMutationOptions, UseMutationResult } from 'react-query';

interface IDataGridContext {
  listQueryKey: string;
  mutationHook?: (
    options: UseMutationOptions<unknown, unknown, Record<string, any>>
  ) => UseMutationResult<unknown, unknown, Record<string, any>>;
  loadingTries?: number;
}

const defaultDataGridContextData: IDataGridContext = {
  listQueryKey: '',
  mutationHook: undefined,
  loadingTries: 0,
};

const DataGridContext = createContext(defaultDataGridContextData);

export function DataGridProvider({ children, ...props }: IDataGridContext & PropsWithChildren) {
  const [data, setData] = useState(defaultDataGridContextData);

  useEffect(() => {
    if ((data.loadingTries || 0) < 10) {
      setData({ ...data, ...props, loadingTries: (data.loadingTries || 0) + 1 });
    }
  }, [props, data]);

  return <DataGridContext.Provider value={data}>{children}</DataGridContext.Provider>;
}

export function useDataGridContext() {
  return useContext(DataGridContext);
}
